import PdfViewer from "../mui-components/PDFViewer";
import { Box, Button, Dialog, DialogContent, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import closeIcon from "../assets/images/close.svg";
import downloadbutton from "../assets/images/downloadicon.svg"
import axios from "axios";
import { configStore } from "../state/CommonState";
import { ApproveRejectComponent } from "../mui-components/ApproveReject";
import MonApi from "../state/mongo-api";
import { taskStore } from "../mytasks/task-store";
import ExcelTable from "../mui-components/ExcelTable";
import { useEffect, useState } from "react";
import blackDownArrow from "../assets/images/blackdownarrow.svg"
import { CustomStyledTextField } from "../mui-components/ColoredTextfield";
import { useMobile } from "../hooks/usemobile";

let server = process.env.REACT_APP_API_SERVER
let items = [{label:"Approve",value:"Approve"},{label:"Reject",value:"Reject"}];

let FileType = {
  word : "WORD",
  pdf : "PDF",
  excel : "EXCEL",
  default : "DEFAULT"
}

export function DocumentViewer({documentTitle,open,onClose,documentUrl,serverUrl,needsApproval=false,reason,isExcel,fileStatus,download,onSubmit}){
  const isMobile = useMobile();
  const handleDownload = async(downloadUrl=serverUrl)=>{
    // console.log(" the download url is ",downloadUrl)
    try {
        const response = await axios(downloadUrl, {
          responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a'); // const buffer = await response.arrayBuffer();
        link.href = url;
        console.log(" the download is ",documentTitle);
        link.setAttribute('download', documentTitle);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        configStore.setModalMessage(error.message)
      }
}
  
  useEffect(()=>{
     const extension = documentUrl?.split(".");
     if( extension && extension[extension?.length-1]==="pdf"){
      setFileType(FileType.pdf)
     }else if(extension && (extension[extension?.length-1]==="doc" || extension[extension?.length-1]==="docx") ){
       handleDownload(documentUrl);
       setFileType(FileType.word);
       onClose();
     }else if(documentUrl?.includes("xlsx") || documentUrl?.includes("xls") || isExcel){
       setFileType(FileType.excel);
     }else{
       setFileType(FileType.default);
     }
  },[documentUrl])


  const [fileType,setFileType] = useState();
  const [fileState,setFileState] = useState(fileStatus);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rejectReason,setRejectReason] = useState(reason);
  const isOpen = Boolean(anchorEl);
  const handleClose = (e) => {
      setAnchorEl(null);
      e.stopPropagation();
  };


console.log(" the file type ",fileType)


  if(!fileType || fileType === FileType.word) return <></>

  return  <Dialog 
            sx={{
              paddingX: isMobile ? 0 : 5,
              paddingY: isMobile ? 0 : 2,
              '& .MuiDialog-paper': {
                margin: isMobile ? 0 : undefined,
                width: isMobile ? '100vw' : undefined,
                maxHeight: isMobile ? '100vh' : undefined,
                borderRadius: isMobile ? 0 : undefined,
              }
            }} 
            open={open} 
            fullScreen 
            fullWidth 
          >
            <Box sx={{display:"flex",flexDirection:"column",height:"100%",width:"100%",backgroundColor:"#F5F5F5",gap:isMobile ? 0 : 2,alignItems:"center"}}>
                <Box sx={{display:"flex",flexDirection:"row",height:isMobile ? "48px" : "40px",width:"100%",backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR,alignItems:"center",paddingX:isMobile ? 1.5 : 2}}>
                    <Typography sx={{fontFamily:"Figtree",color:"white",fontSize:isMobile ? "13px" : "14px",marginRight:"auto",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{documentTitle}</Typography>
                    <Box sx={{display:"flex",flexDirection:"row",alignItems:"center"}} >
                        {download?<Box onClick={()=>{
                          handleDownload();
                        }} sx={{display:"flex",flexDirection:"row",gap:1,alignItems:"center",marginRight:isMobile ? "12px" : "30px",cursor:"pointer"}}>
                            <img src={downloadbutton} alt="Download" />
                            {!isMobile && <Typography sx={{fontFamily:"Figtree",color:"white",fontSize:"14px"}}>Download</Typography>}
                        </Box>:''}
                        <IconButton onClick={onClose} edge="end" sx={{ color: "white" }}>
                            <img src={closeIcon} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>
              {needsApproval && <Box sx={{display:"flex",flexDirection:isMobile ? "column" : "row",minHeight:isMobile ? "auto" : "68px",maxHeight:isMobile ? "none" : "68px",backgroundColor:"white",width:isMobile ? "100%" : "980px",gap:2,alignItems:"center",paddingX:isMobile ? "10px" : "14px",paddingY:isMobile ? "10px" : 0}}>
                      <div onClick={(e)=>{
                        setAnchorEl(e.currentTarget)
                        e.stopPropagation();
                      }} className="h-[43px] w-[177px] border-2 border-solid border-[#D1D1D1] rounded-[3px] flex flex-row gap-1 justify-between items-center px-3 cursor-pointer">
                        <p className="text-[#989898]">{fileState ? fileState : "Select Status"}</p>
                        <img alt="down" src={blackDownArrow} />
                      <Menu
                      sx={{maxHeight:"210px",zIndex: 2000010}}
            anchorEl={anchorEl}
            open={isOpen}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
              {items?.map((item,i)=><MenuItem sx={{
                textAlign:"start",
                wordBreak:"break-word",
                whiteSpace:"normal",
                maxWidth:"300px",margin:"8px", borderRadius:"4px",
               color:"#555555",
              "&:hover":{
                 backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR,
                 color:"white"
              }}} onClick={(e)=>{
                 setFileState(item.value)
                 setAnchorEl(null)
                 e.stopPropagation()
            }} >{item.label}</MenuItem>)}
        </Menu>
                      </div>
                      <div>
{                 fileState && fileState===items[1].value &&  <CustomStyledTextField
                     InputProps={{
                      style:{
                        height:"43px",
                        width:isMobile ? "100%" : "460px"
                      }
                     }}
                     sx={{padding:0,margin:0, 
          '& .MuiOutlinedInput-root': {
      padding: "0px !important", 
      paddingRight:"0px !important"
    },
          "& .MuiFormControl-root .MuiTextField-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent :"center",
            padding:"0px !important"
          },
          "& .MuiInputAdornment-positionEnd": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          "& .MuiOutlinedInput-root": {
          "&.Mui-focused": {
            fieldset: {
              borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
            },
          },
          "&.Mui-error": {
            "&.Mui-focused": {
              fieldset: {
                borderColor: 'red !important', // Color for focused and error state
              },
            },
          },
          "&.Mui-invalid": {
            fieldset: {
              border: 'red !important', // Default focused color
            },
          },
        },
        }} value={rejectReason} onChange={(e)=>{
                            setRejectReason(e.target.value)
                     }} placeholder="Reason for Rejection..." />}
                      </div>
                      <button onClick={async(e)=>{
                        e.stopPropagation();
                        if(onSubmit){
                          await Promise.resolve(onSubmit(fileState,rejectReason));
                         }
                         if(onClose){
                          onClose();
                         }
                      }} type="button" className="flex items-center justify-center text-white bg-blue-dark rounded-[5px] w-[110px] h-[40px] border-0 ml-auto">Submit</button>
                </Box>}
                <Box sx={{display:"flex",flexDirection:"row",width:"100%",height:"100%",justifyContent:"center",backgroundColor:"#F5F5F5",gap:isMobile ? 0 : 2,textAlign:"center",paddingY:isMobile ? 0 : "5px",overflow:"auto","&::-webkit-scrollbar-thumb": {
                    backgroundColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`
                }}}>
                   {fileType===FileType.excel ? <Box sx={{height:isMobile ? "100%" : "98%",width:isMobile ? "100%" : undefined,maxWidth:isMobile ? "100%" : "80%",display:"flex"}}>
                  { documentUrl &&  <ExcelTable url={documentUrl}/>}
                   </Box> : isMobile ? (
                     <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", gap: 2, padding: 3 }}>
                       <Typography sx={{ fontFamily: "Figtree", fontSize: "16px", fontWeight: 600, color: "#1E293B", textAlign: "center" }}>
                         {documentTitle}
                       </Typography>
                       <Button
                         variant="contained"
                         sx={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR || "#2B3990", color: "#fff", textTransform: "none", borderRadius: "10px", px: 4, py: 1.5, fontSize: "15px", fontWeight: 600 }}
                         onClick={() => window.open(documentUrl, '_blank', 'noopener,noreferrer')}
                       >
                         Open Document in New Tab
                       </Button>
                     </Box>
                   ) : (
                     <iframe style={{height:"98%",width:(fileType===FileType.pdf?"80vw" : "80%"),border:0}} 
                     src={`${documentUrl}`} 
                     title={documentTitle}
                     />
                   )}
                   {/* { needsApproval && <ApproveRejectComponent onApprove={onApprove} onReject={onReject} closeDialog={()=>{
                      if(onClose){
                        onClose();
                      }
                   }} onRejectedReason={onRejection} fileName={documentTitle}/>} */}
                </Box>
            </Box>
    </Dialog>
}